import { memo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { reduxForm } from "redux-form";
import SmartRender from "containers/SmartRender";
import validate from "validations";
import {
  makeSelectPageValidations,
  makeSelectFilteredMobileDeviceModels,
  makeSelectSelectedMobileDeviceBrand,
  makeSelectSelectedMobileDevice,
  makeSelectGuestOrder
} from "ducks/selectors";
import { getDOBSecurityHeader, gotoUrl } from "utils/helpers";
import { paths, forms } from "utils/constants";
import {
  submitReplaceSim,
  submitReplaceSimToTelco,
  changeFormField
} from "ducks/actions";
import styles from "./styles";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import {
  makeSelectUpgradeTo5GForm,
  makeSelectUpgradeTo5GPayload,
  makeSelectUpgradeTo5GFormInitialValues
} from "ducks/selectors/forms/upgradeTo5G";

const mapStateToProps = (state, props) =>
  createStructuredSelector({
    styles: () => styles,
    formValues: makeSelectUpgradeTo5GForm(),
    payload: makeSelectUpgradeTo5GPayload(),
    formValidations: makeSelectPageValidations(forms.UPGRADE_TO_5G_FORM),
    messageData: () => ({
      phoneNumber: get(props, "orderDetails.phone_number"),
      simReplacementFee: get(props, "orderDetails.sim_replacement_fee"),
      address: get(props, "orderDetails.address"),
      deliveryDate: get(props, "orderDetails.delivery_date"),
      deliverySlot: get(props, "orderDetails.delivery_slot"),
      stateMessage: get(props, "orderDetails.state_message"),
      instantPickupStartDateTime: get(
        props,
        "orderDetails.instant_pickup_start_date_time"
      ),
      postOfficeName: get(props, "orderDetails.post_office_name")
    }),
    initialValues: makeSelectUpgradeTo5GFormInitialValues(),
    selectedMobileDeviceBrand: makeSelectSelectedMobileDeviceBrand(),
    filteredMobileDeviceModels: makeSelectFilteredMobileDeviceModels(),
    selectedMobileDevice: makeSelectSelectedMobileDevice(),
    order: makeSelectGuestOrder()
  });

export const mapDispatchToProps = dispatch => {
  return {
    onSubmitSimConfigToTelco: (headers, payload, callback) => {
      dispatch(submitReplaceSimToTelco(headers, payload, callback));
    },
    changeField: (field, value) => {
      dispatch(
        changeFormField({
          form: forms.UPGRADE_TO_5G_FORM,
          field: field,
          value: value
        })
      );
    },
    onSubmit: (navigate, payload) => {
      const { skip_form_submission } = payload;
      if (skip_form_submission) {
        navigate();
        return;
      }
      dispatch(
        submitReplaceSim(payload, (result, error) => {
          if (!error) {
            try {
              navigate();
            } catch (err) {
              console.error("Error on submitReplaceSim callback", err);
            }
          } else {
            console.error("Error on submitReplaceSim callback", error);
          }
        })
      );
    }
  };
};

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const submitSimConfigToTelco = () => {
    const headers = getDOBSecurityHeader(stateProps?.formValues?.dob);
    dispatchProps.onSubmitSimConfigToTelco(
      headers,
      stateProps.payload,
      (_, error, status) => {
        if (isEmpty(error) || status === 409) {
          gotoUrl(paths.MANAGE_ORDER);
        } else {
          console.error("Error on submitReplaceSim callback", error);
        }
      }
    );
  };

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onSubmitESimJPConfig: submitSimConfigToTelco,
    onSubmitPhysicalSimJPConfig: submitSimConfigToTelco
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default compose(
  withConnect,
  reduxForm({
    form: forms.UPGRADE_TO_5G_FORM,
    destroyOnUnmount: false,
    validate
  }),
  memo
)(SmartRender);
